import { AxiosResponse } from 'axios'
import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { api } from 'API'
import { IOrganization } from 'interfaces/organization'

export async function createOrganization(organization: IOrganization): Promise<IOrganization> {
  const createdOrganization: AxiosResponse = await api.post(`/organizations`, organization)
  return createdOrganization.data
}

export async function getOrganizations(filter: IFilter<IOrganization> = {}): Promise<IOrganization[]> {
  const organizations: AxiosResponse = await api.get(`/organizations?filter=${JSON.stringify(filter)}`)
  return organizations.data
}

export async function countOrganizations(where: Where<IOrganization> = {}): Promise<number> {
  const organization: AxiosResponse = await api.get(`/organizations/count?where=${JSON.stringify(where)}`)
  return get(organization, 'data.count', 0)
}

export async function updateOrganizationById(organizationId: number, data: Partial<IOrganization>): Promise<void> {
  await api.patch(`/organizations/${organizationId}`, data)
}

export async function getOrganizationById(
  organizationId: string,
  filter: IFilter<IOrganization> = {}
): Promise<IOrganization> {
  const organization: AxiosResponse = await api.get(`/organizations/${organizationId}?filter=${JSON.stringify(filter)}`)
  return organization.data
}
